import { useRef, useState , useEffect } from "react";
import Config from "../../Config";


import gochat from "../../gochat.png";

function QuickChat(props)
{
    const [id, setId] = useState(props.id);
    const [title, setTitle] = useState(props.title);


    const openChat = () => {

        props.mainView.openChat(title, "px_group", id);
    }


    return <sup>
        <img src={gochat} title="Rozpocznij chat"  className="link_normal img_small" onClick={openChat}/>
    </sup>

}


export default QuickChat;